import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useUserConsent } from '@src/features/user-consent/hooks';

import { useAnalytics } from './use-analytics';

let lastTrackedUrl: string;
const getPathNameFromPartialUrl = (urlWithoutOrigin: string) => {
  const url = new URL(urlWithoutOrigin, window.location.origin);
  return url.pathname;
};

export const usePageTracking = () => {
  const router = useRouter();
  const { trackPage } = useAnalytics();
  const { consentStatus } = useUserConsent();

  const track = (url: string) => {
    const trackUrl = getPathNameFromPartialUrl(url);

    // Slight quirk here: Updating query params directly after page load also triggers a routeChangeComplete event (same path), which would result in multiple page views without this check
    if (trackUrl === lastTrackedUrl) {
      return;
    }

    trackPage();
    lastTrackedUrl = trackUrl;
  };

  // Initial page load after consent status is set
  useEffect(() => {
    if (consentStatus) {
      track(router.asPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consentStatus]);

  // Dynamic next.js page transitions
  useEffect(() => {
    const handleRouteChange = (url: string) => {
      track(url);
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
